<template>
  <div class="index-content3">
    <div class="title-container">
      <div class="title-dec-left">
        <img src="@/assets/image/title-dec.png" alt="title decoration left" />
      </div>
      <div class="title-text">酒吧获客，收益多多</div>
      <div class="title-dec-right">
        <img src="@/assets/image/title-dec.png" alt="title decoration right" />
      </div>
    </div>

    <div class="card-show-container">
      <div
        v-for="(card, index) in cardList"
        :key="index"
        class="card"
      >
        <div
          v-if="card.cardTitle"
          class="card-title-container"
        >
          {{ card.cardTitle }}
        </div>
        <div class="card-image">
          <img
            v-if="card.cardImage"
            :src="card.cardImage"
            :alt="card.cardTitle"
          />
        </div>
        <div class="card-content">
          {{ card.cardContent }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexContent3',
  data() {
    return {
      cardList: [
        {
          cardTitle: '祝福上墙，礼物收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/lwsy2_1769061197164736351.webp',
          cardContent: 'Flask酒吧礼物收益数据',
        },
        {
          cardTitle: '土豪霸屏，打赏收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/dxsy2_1769061197163bb9721.webp',
          cardContent: '麦坊酒吧打赏收益数据',
        },
        {
          cardTitle: '扫码点歌，表演收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/bysy2_1769061197164813877.webp',
          cardContent: '醉东酒吧表演收益数据',
        },
        {
          cardTitle: '互动摇骰，游戏收益',
          cardImage: 'https://ustatic.hudongmiao.com/miao/common/yxsy2_1769061197164a7e877.webp',
          cardContent: 'E.P.I.C.酒吧游戏收益数据',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-content3 {
  width: 100%;
  height: auto;
  margin-top: 38px;

  .title-container {
    height: 43px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;

    .title-dec-left {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
      }
    }

    .title-text {
      font-weight: 700;
      font-size: 30px;
      color: #ffffff;
      align-self: flex-end;
      line-height: 1;
    }

    .title-dec-right {
      img {
        width: 75px;
        height: 26px;
        display: block;
        object-fit: contain;
        transform: scaleX(-1);
      }
    }
  }

  .card-show-container {
    margin: 42px auto 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 29px;

    .card {
      width: 266px;
      height: 319px;
      border-radius: 12px;
      border: 2px solid #C95EFB;
      background: linear-gradient(
        270deg,
        rgba(88, 36, 222, 0.8) 0%,
        rgba(167, 70, 209, 0.8) 98.57%
      );
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;

      .card-title-container {
        position: absolute;
        top: 16px;
        left: 50%;
        transform: translateX(-50%);
        width: 278px;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 1.2;
        background-image: url('~@/assets/image/card-title.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
        z-index: 1;
      }

      .card-image {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;

        img {
          width: 262px;
          height: 217px;
          display: block;
          object-fit: contain;
        }
      }

      .card-content {
        margin-top: auto;
        margin-bottom: 27px;
        padding: 0 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        white-space: nowrap;

        &::before,
        &::after {
          content: '';
          display: block;
          flex: 1;
          height: 1px;
          background: #FFFFFF;
          opacity: 0.8;
          margin: 0 6px;
        }
      }
    }
  }
}
</style>
